export default {
  BranchList: {
    Title: 'Đơn vị trực thuộc',
    DictionaryBranch: '/ Đơn vị trực thuộc',
    Dictionary: 'Danh mục',
    Placeholder: 'Tìm kiếm theo Mã đơn vị, Tên đơn vị...',
  },
  BranchDetail: {
    BranchCode: 'Mã đơn vị *',
    BranchName: 'Tên đơn vị *',
    ParentName: 'Thuộc đơn vị',
    Description: 'Diễn giải',
  },
};
